import { useAppSelector } from 'app/state'

export function useMeUser() {
  const me = useAppSelector((state) => state.users.me)
  return me
}
